










































import { Vue, Prop, Component } from 'vue-property-decorator';
import { ReceiptViewModel, DeliveryMethodViewObject, PaymentMethodViewObject } from '@/types/apiServerContract';

@Component
export default class ConfirmationPageOrderInformation extends Vue {
    @Prop({
        required: true,
        type: Object
    }) model!: ReceiptViewModel;

    deliveryMethod: DeliveryMethodViewObject | null = null;
    paymentMethod: PaymentMethodViewObject | null = null;

    created() {
        this.deliveryMethod = this.model.deliveryMethod ?? null;
        this.paymentMethod = this.model.paymentMethod ?? null;
    }
};
